import { Component, OnInit } from '@angular/core';
import { GifcardVirtualService } from 'src/app/services/gifcardVirtual.service';
import { MessageService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ImageService } from 'src/app/services/image.service';
import { AuthService } from 'src/app/services/auth.service';
import { GiftCardModel, GiftCardClientsModel } from 'src/app/models/gifcardVirtual.model';
import { FileUploadValidators } from '@iplab/ngx-file-upload';
import { ImageText, ImageBarcode } from 'src/app/models/image.model';
import { saveAs } from 'file-saver';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-template-add-upd',
  templateUrl: './template-add-upd.component.html',
  styleUrls: ['./template-add-upd.component.css']
})
export class TemplateAddUpdComponent implements OnInit {

    id_modelo_gift_card: string;
    id_template: string;
    id_cliente: string;

    templateFormGroup: FormGroup;    
    datasourceSelectModels: GiftCardModel[] = [];
    datasourceImageBarcode: ImageBarcode[] = [];
    datasourceImageText: ImageText[] = [];
    newTemplate: boolean = true;
    fileModel = new FormControl(null, [FileUploadValidators.filesLimit(1), Validators.required]);
    colsTablaImageBarcode: any[];
    colsTablaImageText: any[];
    userCurrent: string;
    displayBarcode: boolean = false;
    displayText: boolean = false;
    displayPanelEdit: boolean = true;
    fileModelPath: string;
    template;
    itemBarcode;
    selectBarcode;
    itemText;
    selectText;
    
    selectYesNo: SelectItem[];
    selectColor: SelectItem[];
    selectFont: SelectItem[];

    imagePreviewPath: string;

    selectClient: GiftCardClientsModel;
    datasourceSelectClient: GiftCardClientsModel[] = [];
    filteredClients: Observable<GiftCardClientsModel[]>;

    loading: boolean = false;
    
  constructor(private giftCardService: GifcardVirtualService, 
    private messageService: MessageService,
    private formBuilder: FormBuilder,
    private imageService: ImageService,
    private authService: AuthService) { }

  ngOnInit() { 
      this.userCurrent = this.authService.getCurrentUser();
      this.template = JSON.parse(this.imageService.getTemplateEdit());
      console.log(this.template);
      this.populateSelectModels();
      this.populateSelectClient();
      this.createModelsForm();
      this.createColumnTableBarcode();
      this.createColumnTableText();
      this.createSelectForm();
      
      if (this.template){
          this.newTemplate = false;       
          this.id_template = this.template.ID_TEMPLATE;     
          this.id_modelo_gift_card = this.template.ID_TYPES;
          this.fileModelPath = this.template.IMG_MODELO_GIFT_CARD;
          this.modelo_gif2.setValue(this.id_modelo_gift_card, {onlySelf: true});
          this.modelo_gif2.disable();
          this.cliente_gif2.setValue(this.template.NRORUC_CLIENTE);
          this.cliente_gif2.disable();
          this.ruc_comprador2.setValue(this.template.NRORUC_CLIENTE);
          this.ruc_comprador2.disable();
          this.razon_comprador2.setValue(this.template.RAZSOC_CLIENTE);
          this.razon_comprador2.disable();
          this.desc_template.setValue(this.template.DESC_TEMPLATE);
          this.populateTableImageBarcode(this.id_template);
          this.populateTableImageText(this.id_template); 
      }
      else{
          this.newTemplate = true;
          this.populateTableImageBarcodeNew();
          this.populateTableImageTextNew();
      }  

      this.filteredClients = 
      this.cliente_gif2.valueChanges.pipe(
          startWith(''),
              map(value => typeof value === 'string' ? value : value.NRORUC_CLIENTE),
              map(value => value ? this.filterRUC(value) : this.datasourceSelectClient.slice())
          );
  }

  filterRUC(value: string): GiftCardClientsModel[] {
    const filterValue = value.toLowerCase();    
    return this.datasourceSelectClient.filter(client => client.NRORUC_CLIENTE.toLowerCase().indexOf(filterValue) === 0);
  }

  displayFn(client?: GiftCardClientsModel): string | undefined {
    return client ? client.NRORUC_CLIENTE : undefined;
  }

  createModelsForm(){
      this.templateFormGroup = this.formBuilder.group({
          selModeloGiftCard: ['', Validators.required],
          selClientGiftCard: ['', Validators.required],
          txtNroRUCComprador: new FormControl({value: '', disabled: true}, Validators.required),
          txtRazSocComprador: new FormControl({value: '', disabled: true}, Validators.required),
          txtDescTemplate: ['', Validators.required], 
          imgModeloGiftCard: this.fileModel
      });
  }

  createColumnTableBarcode(){
      this.colsTablaImageBarcode = [
          {field: "AXIS_X", header: "Eje X"},
          {field: "AXIS_Y", header: "Eje Y"},
          {field: "SIZE", header: "Tamaño"},
          {field: "VIEW_VALUE", header: "Ver Valor"}
      ]
  }

  createColumnTableText(){
      this.colsTablaImageText = [
          {field: "KEY_TEXT", header: "Clave"},
          {field: "AXIS_X", header: "Eje X"},
          {field: "AXIS_Y", header: "Eje Y"},
          {field: "TEXT_COLOR", header: "Color"},
          {field: "TEXT_FONT", header: "Fuente"},
          {field: "TEXT_FONT_SIZE", header: "Tamaño"},
      ]
  }

  createSelectForm(){
      this.selectYesNo = [
          {label:'SI', value: 1},
          {label:'NO', value: 0}
      ]

      this.selectColor = [
          {label:'Blanco', value: 'white'},
          {label:'Negro', value: 'black'},
          {label:'Azul', value: 'blue'},
          {label:'Rojo', value: 'red'}
      ]

      this.selectFont = [
          {label:'Arial', value: 'Arial'}
      ]
  }

  populateSelectModels(){
      this.giftCardService.GetGiftCardModels().subscribe(
          (response: GiftCardModel[]) => {            
              this.datasourceSelectModels = response; 
              this.loading = false;   
          },
          (error) => {
              this.loading = false;
              this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al listar tipos locales de gift card.'});
          }
      )
  }

  populateSelectClient(){                
    this.giftCardService.GetGiftCardClients().subscribe(
      (response: GiftCardClientsModel[]) => {            
          this.datasourceSelectClient = response;         
      },
      (error) => {
          this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al listar clientes.'});
      }
    )
  }

  populateTableImageBarcode(idTemplate){
      let params = {"p_id_template" : idTemplate};
      this.imageService.GetGiftCardBarcode(params).subscribe(
          (response: ImageBarcode[]) => {            
              this.datasourceImageBarcode = response;
          },
          (error) => {
              this.loading = false;
              this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al listar info image barcode.'});
          }
      )
  }

  populateTableImageText(idTemplate){
      let params = {"p_id_template" : idTemplate};
      this.imageService.GetGiftCardText(params).subscribe(
          (response: ImageText[]) => {            
              this.datasourceImageText = response;                
          },
          (error) => {
              this.loading = false;
              this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al listar info image text.'});
          }
      )
  }

  populateTableImageBarcodeNew(){
      this.datasourceImageBarcode = this.imageService.defaultItemTableImageBarcode();
  }

  populateTableImageTextNew(){
      this.datasourceImageText = this.imageService.defaultItemsTableImageText();
  }

  onSelectClient(client){        
    if (client){
        this.id_cliente = client.ID_CLIENTE.toString();
        this.ruc_comprador2.setValue(client.NRORUC_CLIENTE);
        this.razon_comprador2.setValue(client.RAZSOC_CLIENTE);
    }     
  }

  saveTemplate(){
      if (this.newTemplate){
          if (this.templateFormGroup.valid){
              this.loading = true;

              if (!this.fileModel.value){
                  this.messageService.add({severity:'error', summary: 'Error', detail:'Debe seleccionar 01 archivo tipo imagen del modelo.'});  
              }
              else if (!this.fileModel.valid){
                  this.messageService.add({severity:'error', summary: 'Error', detail:'Debe seleccionar solo 01 archivo tipo imagen del modelo.'});
              }
              else{
                  this.id_modelo_gift_card = this.modelo_gif2.value;
                  let template = new FormData();
                  template.append("p_id_cliente", this.id_cliente);
                  template.append("p_id_modelo_gift_card", this.id_modelo_gift_card);
                  template.append("p_desc_template", this.desc_template.value);
                  template.append('file_img_modelo_gift_card', this.fileModel.value[0]);
                  template.append("p_creationuser", this.userCurrent);

                  this.imageService.CreateGiftCardTemplate(template).subscribe(
                      (response) => {
                          let json = response;                    
                          this.id_template = json.NEW_ID_TEMPLATE;
                          this.fileModelPath = json.IMAGE_MODEL;
                          this.newTemplate = false;
                          this.createImageBarcode();
                          this.createImageText();
                          this.disabledControls();
                          this.messageService.add({severity:'success', summary: 'Éxito', detail:'El modelo se registro correctamente.'});
                      },
                      (error) => {
                          this.loading = false;
                          this.newTemplate = true;
                          this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al registrar el modelo.'});
                      }
                  )
              }
          }
          else{
              this.messageService.add({severity:'error', summary: 'Error', detail:'Ingrese todos los campos obligatorios.'});
          }
      }
      else{
          this.updateTemplate();
      }                
  }

  updateTemplate(){
    this.loading = true;
    let template = {
      "p_id_template": this.id_template,
      "p_desc_template": this.desc_template.value, 
      "p_flag_activo" : 1
    };
    this.imageService.UpdateGiftCardTemplate(template).subscribe(
      (response) => {        
          this.updateImageBarcode();            
          this.messageService.add({severity:'success', summary: 'Éxito', detail:'El modelo se actualizó correctamente.'});
      },
      (error) =>{
        this.loading = false;
        this.messageService.add({severity:'success', summary: 'Éxito', detail:'Ocurrio un error al actualizar el modelo.'});
      }
    );
  }

  disabledControls(){
      this.modelo_gif2.disable();
      this.cliente_gif2.disable();
      this.ruc_comprador2.disable();
      this.razon_comprador2.disable();
  }

  createImageBarcode(){
      this.datasourceImageBarcode.forEach(barcode => {
          let params = {
              "p_id_template" : this.id_template,
              "p_axis_x" : barcode.AXIS_X,
              "p_axis_y" : barcode.AXIS_Y,
              "p_size" : barcode.SIZE,
              "p_view_value" : barcode.VIEW_VALUE,
              "p_creationuser" : this.userCurrent
          }
          this.imageService.CreateImageBarcode(params).subscribe(
              (response) => {
                  this.populateTableImageBarcode(this.id_template);                    
              },
              (error) =>{
                  this.loading = false;
              }

          )
      });        
  }

  createImageText(){
      this.datasourceImageText.forEach(text => {
          let params = {
              "p_id_template" : this.id_template,
              "p_key_text" : text.KEY_TEXT,
              "p_axis_x" : text.AXIS_X,
              "p_axis_y" : text.AXIS_Y,
              "p_text_color" : text.TEXT_COLOR,
              "p_text_font" : text.TEXT_FONT,
              "p_text_font_size" : text.TEXT_FONT_SIZE,
              "p_creationuser" : this.userCurrent
          };

          this.imageService.CreateImageText(params).subscribe(
              (response) => {
                  this.populateTableImageText(this.id_template);   
                  this.loading = false;                 
              },
              (error) =>{
                  this.loading = false;
              }
          )
      });
  }

  updateImageBarcode(){
      this.datasourceImageBarcode.forEach(barcode => {
          let params = {
              "p_id_barcode" : barcode.ID_BARCODE,
              "p_id_template" : this.id_template,
              "p_axis_x" : barcode.AXIS_X,
              "p_axis_y" : barcode.AXIS_Y,
              "p_size" : barcode.SIZE,
              "p_view_value" : barcode.VIEW_VALUE,
              "p_flg_activo" : barcode.FLG_ACTIVO
          }
          this.imageService.UpdateGiftCardBarcode(params).subscribe(
              (response) => {
                  this.populateTableImageBarcode(this.id_template);     
                  this.updateImageText();
              },
              (error) =>{
                  this.loading = false;
              }

          )
      });     
  }

  updateImageText(){
      this.datasourceImageText.forEach(text => {
          let params = {
              "p_id_text" : text.ID_TEXT,
              "p_id_template" : this.id_template,
              "p_key_text" : text.KEY_TEXT,
              "p_axis_x" : text.AXIS_X,
              "p_axis_y" : text.AXIS_Y,
              "p_text_color" : text.TEXT_COLOR,
              "p_text_font" : text.TEXT_FONT,
              "p_text_font_size" : text.TEXT_FONT_SIZE,
              "p_flg_activo" : text.FLG_ACTIVO
          };

          this.imageService.UpdateGiftCardText(params).subscribe(
              (response) => {
                  this.populateTableImageText(this.id_template);   
                  this.loading = false;                 
              },
              (error) =>{
                  this.loading = false;
              }
          )
      });
  }

  createImage(){
      let myImage = new Image();    
      this.imageService.buildImageUrl(this.fileModelPath);
      this.datasourceImageText.forEach(item => {
          if (item.KEY_TEXT == this.imageService.KEY_TEXTO) item.TEXT = 'TEXTO POR DEFECTO';
          else if (item.KEY_TEXT == this.imageService.KEY_NOMBRE) item.TEXT = 'NOMBRE POR DEFECTO';
          else if (item.KEY_TEXT == this.imageService.KEY_DNI) item.TEXT = '00000000';
          else if (item.KEY_TEXT == this.imageService.KEY_SECUENCIAL) item.TEXT = '123456';
          else if (item.KEY_TEXT == this.imageService.KEY_VIGENCIA) item.TEXT = 'VALIDO DEL 10/10/99 AL 10/10/00';
      });
      this.datasourceImageBarcode[0].BIN = "212121999000000";
      this.imageService.createBarcode(this.datasourceImageBarcode[0]).then(load => {
          if (load){                    
              this.imageService.textImage(this.datasourceImageText);
              let data = this.imageService.getContext().getImageData(0, 0, this.imageService.getCanvas().width, this.imageService.getCanvas().height);
              this.imageService.getContext().putImageData(data, 0, 0);           
              myImage.src = this.imageService.getCanvas().toDataURL("images/jpeg");
              this.imagePreviewPath = myImage.src;
          }
      });
  }

  onRowBarcode(event){
      this.itemBarcode = this.cloneItemBarcode(event.data);
      this.displayBarcode = true;
  }

  onRowText(event){
      this.itemText = this.cloneItemText(event.data);
      this.displayText = true;
  }

  cloneItemBarcode(item: ImageBarcode): ImageBarcode {
      let grupo = {};
      for (let prop in item) {
          grupo[prop] = item[prop];
      }
      return item;
  }

  cloneItemText(item: ImageText): ImageText {
      let grupo = {};
      for (let prop in item) {
          grupo[prop] = item[prop];
      }
      return item;
  }

  updateBarcode(){
      let tmp = [...this.datasourceImageBarcode];
      tmp[this.datasourceImageBarcode.indexOf(this.selectBarcode)] = this.itemBarcode;
      this.datasourceImageBarcode = tmp;
      this.itemBarcode = null;
      this.displayBarcode = false; 
  }

  updateText(){
      let tmp = [...this.datasourceImageText];
      tmp[this.datasourceImageText.indexOf(this.selectText)] = this.itemText;
      this.datasourceImageText = tmp;
      this.itemText = null;
      this.displayText = false; 
  }

  downloadImage(){
      this.imageService.getCanvas().toBlob(function(blob) {
          saveAs(blob, "image.jpeg");
      });
  }

  downloadImageModel(){
      saveAs(this.fileModelPath, "image.jpeg");
  }

  restablecerValues(){
      let listImageBarcodeDefault: ImageBarcode[] = this.imageService.defaultItemTableImageBarcode();
      let listImageTextDefault: ImageText[] = this.imageService.defaultItemsTableImageText();

      listImageBarcodeDefault.forEach(barcode => {
          this.datasourceImageBarcode[0].AXIS_X = barcode.AXIS_X;
          this.datasourceImageBarcode[0].AXIS_Y = barcode.AXIS_Y;
          this.datasourceImageBarcode[0].SIZE = barcode.SIZE;
          this.datasourceImageBarcode[0].VIEW_VALUE = barcode.VIEW_VALUE;
      });

      listImageTextDefault.forEach(textTmp => {
          this.datasourceImageText.forEach(text => {
              if (textTmp.KEY_TEXT == text.KEY_TEXT){
                  text.AXIS_X = textTmp.AXIS_X;
                  text.AXIS_Y = textTmp.AXIS_Y;
                  text.TEXT_COLOR = textTmp.TEXT_COLOR;
                  text.TEXT_FONT = textTmp.TEXT_FONT;
                  text.TEXT_FONT_SIZE = textTmp.TEXT_FONT_SIZE;
                  return;
              }
          });
      });
  }

  onBack(){
      this.imageService.removeTemplateEdit();
  }

  get modelo_gif2(){
      return this.templateFormGroup.get('selModeloGiftCard');
  }

  get imgModel(){
      return this.templateFormGroup.get('imgModeloGiftCard');
  }

  get cliente_gif2(){
    return this.templateFormGroup.get('selClientGiftCard');
  }

  get ruc_comprador2() { 
      return this.templateFormGroup.get('txtNroRUCComprador'); 
  }

  get razon_comprador2() { 
      return this.templateFormGroup.get('txtRazSocComprador'); 
  }

  get desc_template() { 
    return this.templateFormGroup.get('txtDescTemplate'); 
}

}
